import { sortingTable } from 'utils/_sort.js'
import ajaxRequest from 'utils/_ajax-request.js'
import {loadingWindowHidden, loadingWindowVisible} from "../loading/_index";
import notificationBell from 'utils/_notification_bell.js'
import updateOrderList from 'utils/_update-order-list.js'


const loadNewOrders = () => {
  let searchParams = new URLSearchParams(window.location.search);
  if( searchParams.has('order_id') ) {
    searchParams.delete('order_id')
  }
  if( searchParams.has('user_id') ) {
    searchParams.delete('user_id')
  }

  const url = '/ru/admin/orders/new-orders' + '?lastOrderId=' + lastOrderId + '&lastTimeRequest=' + lastTimeRequest + '&' + searchParams.toString()

  ajaxRequest(afterLoadNewOrders, url, {}, 'GET')
}

let afterLoadNewOrders = (xhr, error) => {
  if( error ) {
    return false
  }

  let data = JSON.parse(xhr.responseText)

  if( data.hasOwnProperty('isExistNewOrders') && data['isExistNewOrders'] ) {
    //console.log('song')


    const userRoleEl = document.getElementById('user_role')
    if( userRoleEl && userRoleEl.value == 'senior' ) {
      soundNotification()
    }

    /*if( audioElement ) {
      soundNotification()
    }*/

    /*let audioObj = document.getElementById('notification-audio');
    if( audioObj ) {
      audioObj.volume = 1.0
      audioObj.play()
    }*/

    if( data.hasOwnProperty('lastOrderId') ) {
      lastOrderId = data['lastOrderId']
    }

    if( data.hasOwnProperty('lastTimeRequest') ) {
      lastTimeRequest = data['lastTimeRequest']
    }

    updateOrderList(data)
  }
}

function soundNotification() {
  for(let audio of audiosWeWantToUnlock) {
    audio.play()
  }
}


function unlockAudioTouch() {
  playStopSound()
  document.body.removeEventListener('touchstart', unlockAudioTouch)
}

function unlockAudioClick() {
  playStopSound()
  document.body.removeEventListener('click', unlockAudioClick)
}

function playStopSound() {
  for(let audio of audiosWeWantToUnlock) {
    audio.play()
    //audio.volume = 0.1
    audio.pause()
    audio.currentTime = 0

    /*setTimeout(function(){
      console.log('setTimeout')
      soundNotification()
    }, 5000)*/

    const userRoleEl = document.getElementById('user_role')
    if( userRoleEl && userRoleEl.value == 'senior' ) {
      const isExistNewOrder = document.getElementById('is_exist_new_order')
      if( isExistNewOrder && isExistNewOrder.value == 1 ) {
        soundNotification()
      }
    }

  }
}


let lastOrderId = 0
let lastTimeRequest = 0

let touchStartOn = function(el, x, y) {
  var e, err;
  if (x == null) {
    x = 0;
  }
  if (y == null) {
    y = 0;
  }
  try {
    e = document.createEvent('TouchEvent');
    e.initTouchEvent("touchstart", true, true);
  } catch (_error) {
    err = _error;
    try {
      e = document.createEvent('UIEvent');
      e.initUIEvent("touchstart", true, true);
    } catch (_error) {
      err = _error;
      e = document.createEvent('Event');
      e.initEvent("touchstart", true, true);
    }
  }
  e.targetTouches = [
    {
      pageX: x,
      pageY: y
    }
  ];
  el.dispatchEvent(e);
};

var audiosWeWantToUnlock = []
audiosWeWantToUnlock.push(new Audio('/notification_sound.mp3'))


//let audioElement = new Audio('/notification_sound.mp3')

var firstPlay = true;

export default (
  selector
) => {

  sortingTable(selector, 'two')

  notificationBell()


  const lastTimeRequestField = document.getElementById('last_time_request')
  if( lastTimeRequestField ) {
    lastTimeRequest = lastTimeRequestField.value
  }

  const lastOrderIdField = document.getElementById('last_order_id')
  if( lastOrderIdField ) {
    //console.log(lastOrderIdField.value)
    lastOrderId = lastOrderIdField.value

    setInterval(function(){loadNewOrders()}, 60000)

    document.body.addEventListener('click', unlockAudioClick, false);
    document.body.addEventListener('touchstart', unlockAudioTouch, false);
  }


  const userRoleEl = document.getElementById('user_role')
  if( userRoleEl && userRoleEl.value == 'senior' ) {
    const isExistNewOrder = document.getElementById('is_exist_new_order')
    if( isExistNewOrder && isExistNewOrder.value == 1 ) {
      soundNotification()
    }
  }

}

